import EmailTemplates from './container/index';

export default EmailTemplates;


// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/index.js